<!-- eslint-disable vue/prop-name-casing -->
<script setup>
import { useModal } from 'vue-final-modal';
import NewForm from '~/forms/components/new-form/new-form-modal.vue';
import { useThermStore } from '~/therm/store/therm.store.js';

const props = defineProps({
  marker_location: {
    type: Object,
    default: () => null,
  },
  project_details_for_task_form_creation: {
    type: Object,
    default: () => null,
  },
  opened_from: {
    type: String,
    default: 'Direct',
  },
  template_uid: {
    type: String,
    default: '',
  },
  form_data: {
    type: Object,
    default: null,
  },
  create_form_on_load: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'formCreated']);
const $toast = inject('$toast');
const $form_create_permission = inject('$form_create_permission');
const therm_store = useThermStore();

const { open: openForm, close: closeNewForm } = useModal({
  component: NewForm,
  attrs: {
    clickToClose: true,
    fields: [
      'Form Name',
      'Template',
      'Assignees',
      'Checkbox',
      'Start Date',
      'Due Date',
      'Tags',
      'Category',
      'Prefix feature name',
    ],
    onClose() {
      closeNewForm();
      emit('close');
    },
    on_cancel() {
      closeNewForm();
      emit('close');
    },
    form_data: props.form_data,
    event_properties: {
      bulk: therm_store.selected_features.length > 1,
      how: props.opened_from,
    },
    async on_submit(data) {
      await createForm(data);
      closeNewForm();
    },
  },
});

async function createForm(data) {
  try {
    const response = await therm_store.create_therm_forms({
      issues: therm_store.selected_features,
      form_data: data.forms.add[0],
    });
    if (response?.forms?.added?.length) {
      emit('formCreated', { uid: response.forms.added[0].uid, status: 'open' });
      emit('close');
    }
  }
  catch (err) {
    logger.log(err);
  }
}

if ($form_create_permission?.value?.state === 'enabled')
  openForm();
else
  $toast({ text: 'Permission Denied!', type: 'error' });
</script>

<template>
  <div />
</template>
